export const enterpriseSubscriptionPlans =
{
    free: {
        DescriptionData: [
            'Limited features',
            'Access to last 7 days data',
            'Data older than 3 months will be deleted',
        ]
    },
    yearly: {
        ProPlan: {
            DescriptionData: [
                'Unlimited Teams',
                'Unlimited Users',
                'Project Synchronization',
                'Live Tracking of drones on Cloud',
                'Business Analytics',
                'Drone Performance Analytics',
                'Replay of Flight',
                'Flight logs with analytics',
                '8*5 Days Standard Support'
            ]
        },
        BusinessPlan: {
            DescriptionData: [
                'Unlimited Teams',
                'Unlimited Users',
                'Project Synchronization',
                'Live Tracking of drones on Cloud',
                'Business Analytics',
                'Drone Performance Analytics',
                'Replay of Flight',
                'Flight logs with analytics',
                '8*5 Days Standard Support',
                'Live Video Streaming',
            ]
        },
        EnterprisePlan: {
            DescriptionData: [
                'Unlimited Teams',
                'Unlimited Users',
                'Project Synchronization',
                'Live Tracking of drones on Cloud',
                'Flight logs with analytics',
                'Business Analytics',
                'Drone Performance Analytics',
                'Replay of Flight',
                '8*5 Days Standard Support',
                'Live Video Streaming',
                'AeroGCS Enterprise API',
            ]
        }
    },
    monthly: {
        ProPlan: {
            DescriptionData: [
                'Unlimited Teams',
                'Unlimited Users',
                'Project Synchronization',
                'Live Tracking of drones on Cloud',
                'Flight logs with analytics',
                'Business Analytics',
                'Drone Performance Analytics',
                'Replay of Flight',
                '8*5 Days Standard Support',
            ]
        },
        BusinessPlan: {
            DescriptionData: [
                'Unlimited Teams',
                'Unlimited Users',
                'Project Synchronization',
                'Live Tracking of drones on Cloud',
                'Flight logs with analytics',
                'Business Analytics',
                'Drone Performance Analytics',
                'Replay of Flight',
                '8*5 Days Standard Support',
                'Live Video Streaming'
            ]
        },
        EnterprisePlan: {
            DescriptionData: [
                'Unlimited Teams',
                'Unlimited Users',
                'Project Synchronization',
                'Live Tracking of drones on Cloud',
                'Flight logs with analytics',
                'Business Analytics',
                'Drone Performance Analytics',
                'Replay of Flight',
                '8*5 Days Standard Support',
                'Live Video Streaming',
                'AeroGCS Enterprise API'
            ]
        }
    }
}
